import { api } from './api';
import type { QueueItem } from '../types';

export interface FailedQueueItem extends QueueItem {
  error_message?: string | null;
  retry_count?: number;
  last_attempt_at?: string | null;
  posted_manually?: number;
}

export const publishQueueApi = {
  list: (params?: { manager_id?: number; status?: string; niche?: string }) => {
    const qs = new URLSearchParams();
    if (params?.manager_id) qs.set('manager_id', params.manager_id.toString());
    if (params?.status) qs.set('status', params.status);
    if (params?.niche) qs.set('niche', params.niche);
    return api.get<QueueItem[]>(`/publish-queue?${qs}`);
  },
  create: (data: Partial<QueueItem>) =>
    api.post<{ id: number }>('/publish-queue', data),
  updateStatus: (id: number, status: string) =>
    api.patch(`/publish-queue/${id}`, { status }),
  assign: (id: number, managerId: number) =>
    api.post(`/publish-queue/${id}/assign`, { manager_id: managerId }),

  // Iter2: failure recovery
  listFailed: (niche?: string, limit = 50) => {
    const qs = new URLSearchParams();
    if (niche) qs.set('niche', niche);
    qs.set('limit', String(limit));
    return api.get<FailedQueueItem[]>(`/publish-queue/failed?${qs}`);
  },
  markPostedManual: (id: number) =>
    api.post<{ id: number; status: string; manual: boolean }>(
      `/publish-queue/${id}/mark-posted-manual`,
      { confirm: true },
    ),
  retry: (id: number) =>
    api.post<{ id: number; status: string }>(`/publish-queue/${id}/retry`, {}),
  discard: (id: number) =>
    api.post<{ id: number; status: string }>(`/publish-queue/${id}/discard`, {}),
};
